import React, { useContext, useEffect, useState } from 'react';
import { useFetch } from '../api/useFetch';
import { useUserContext } from './user_context';

export const InvoiceContext = React.createContext();


export const InvoiceProvider = ({ children }) => {


    const { btoken, stoken } = useUserContext();


    let data = { btoken, stoken };
    const {
        loading: invoiceLoading, data: invoiceData, fetchData: getInvoiceData
    } = useFetch('/invoice.home', data);




    return (
        <InvoiceContext.Provider value={{

            invoiceLoading, invoiceData, getInvoiceData

        }}>
            {children}
        </InvoiceContext.Provider>
    );
};

// make sure use
export const useInvoiceContext = () => {
    return useContext(InvoiceContext);
};
